import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

let saveAuthHandler = null;
export const setSaveAuthHandler = (handler) => { saveAuthHandler = handler; };

api.interceptors.response.use((response) => response, (error) => {
  const config = error.config;
  const path = config?.url ? new URL(config.url, window.location.origin).pathname.replace(/^\/api/, "") : "";
  if (error.response?.status === 401 && saveAuthHandler && !config?._authResumed && ["post", "put"].includes(config?.method) && /^\/(bucket|trips|saves|packing)(\/[A-Za-z0-9_-]+)?$/.test(path)) {
    return saveAuthHandler({ ...config, _authResumed: true }, path);
  }
  return Promise.reject(error);
});

export const fileUrl = (path) => (path ? `${API}/files/${path}` : null);

export default api;
